export const MATERIAL_ICON_NAME = {
  search: 'search',
  ios_share: 'ios_share',
  share: 'share',
  favorite: 'favorite',
  shoppingCart: 'shopping_cart',
  orders: 'orders',
  arrow_back: 'arrow_back',
  mail: 'mail',
  chevron_right: 'chevron_right',
  arrow_upward: 'arrow_upward',
  more_horiz: 'more_horiz',
  keyboard_arrow_down: 'keyboard_arrow_down',
  keyboard_arrow_up: 'keyboard_arrow_up',
  edit: 'edit',
  star: 'star',
  delete: 'delete',
  more_vert: 'more_vert',
  add: 'add',
  lock: 'lock',
  location_on: 'location_on',
  info: 'info',
  close: 'close',
  local_shipping: 'local_shipping',
  package_2: 'package_2',
  help: 'help',
  logout: 'logout',
  progress_activity: 'progress_activity',
  undo: 'undo',
  check:'check'
};
